import React from "react";
import PropTypes from "prop-types";
import { List } from "immutable";
import { Row, Col} from "antd";
import { Table } from "components";


class CompanyLosProfileTable extends React.Component {
    tableHeight = 500;
    componentDidMount() {
        const bodyEl = document.getElementsByTagName("body");
        this.tableHeight = bodyEl[0].offsetHeight * 0.60;
    }
    onFilter = values => {
        this.props.onFilter(values);
    }
    onPageChange = (page, pageSize) => {
        this.props.onPageChange(page, pageSize);
    }
    render() {
        const {
            columns,
            data,
            totalCount,
            loading,
            currentPage,
        } = this.props;
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <Table
                            title={"Companies"}
                            columns={columns}
                            checkedColumns={columns && columns.size ? columns.toList() : new List([])}
                            filterColumns={columns && columns.size ? columns.toList() : new List([])}
                            data={data}
                            keyFilter={"id"}
                            ignoreKeyFilter={false}
                            showBulkDropdown={true}
                            showXlsxBtn={true}
                            showAssetBtn={false}
                            showTitle={true}
                            showFilters={true}
                            spanConfig={{
                                title: 6,
                                btnSpan: 6,
                                filters: 12
                            }}
                            fixedColsLeft={["name"]}
                            fixedColsRight={["approved_limit"]}
                            loading={loading}
                            size={"small"}
                            editable={false}
                            showFooter={false}
                            showTotalPages={true}
                            showPaginationOnly={false}
                            pagination={{
                                currentPage,
                                showSizeChanger: true,
                                defaultPageSize: 15,
                                pageSizeOptions: [
                                    "15",
                                    "20",
                                    "50",
                                    "100",
                                    "500"
                                ],
                                position: "bottom",
                                total: totalCount,
                                onChange: this.onPageChange,
                                onShowSizeChange: this.onPageChange
                            }}
                            onFilter={this.onFilter}
                            bordered={true}
                            scrollY={this.tableHeight}
                        />
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

CompanyLosProfileTable.propTypes = {
    data: PropTypes.object,
    columns: PropTypes.object,
    currentPage: PropTypes.number,
    loading: PropTypes.bool,
    totalCount: PropTypes.number,
    onFilter: PropTypes.func,
    onPageChange: PropTypes.func,
    searchValue: PropTypes.string
};

export default CompanyLosProfileTable;
